import { Link } from 'react-router-dom';
import rightIcon from '../assets/chevron_right_gray.svg';

const Breadcrumb = ({ items }) => {
  return (
    <div className="flex items-center gap-2 text-sm">
      {items.map((item, index) => (
        <div key={index} className="flex items-center">
          {index > 0 && <img src={rightIcon} className="w-4 h-4 text-[#aaaaaa] mx-2" />}
        
          {item.href ? (
            <Link to={item.href} className="text-[#aaaaaa] hover:text-[#111111]">
              {item.label}
            </Link>
          ) : (
            <span className="text-[#111111]">{item.label}</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default Breadcrumb; 